import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { ProcessResponse } from "../models/caster.models";
import { ReadyToCastHeatsResponse } from "../models/catalogs.models";

const moment = getMomentTz();

export const getCasterProcess = async ({
  ProcessId = null,
}: {
  ProcessId: number | null;
}) => {
  const apiService = new MESApiService();

  const resp = await apiService.callV2("[CAS].[DEGetProcess]", [
    { name: "ProcessId", value: ProcessId },
  ]);

  if (resp.ok) {
    const data = resp.data as ProcessResponse;

    const process = data.tables[0].rows[0];

    data.tables[0].rows[0] = {
      ...data.tables[0].rows[0],
      LadleOpen: process.LadleOpen
        ? moment.utc(process["LadleOpen"]).toDate()
        : null,
      Start: moment.utc(process["Start"]).toDate(),
      LadleClose: process.LadleClose
        ? moment.utc(process["LadleClose"]).toDate()
        : null,
      End: process.End ? moment.utc(process["End"]).toDate() : null,
      TapTime: process.TapTime ? moment.utc(process["TapTime"]).toDate() : null,
    };
    data.tables[1].rows = data.tables[1].rows.map((row) => ({
      ...row,
      StrandLossStart: row.StrandLossStart
        ? moment.utc(row.StrandLossStart).toDate()
        : null,
      StrandLossEnd: row.StrandLossEnd
        ? moment.utc(row.StrandLossEnd).toDate()
        : null,
      FirstCutTime: row.FirstCutTime
        ? moment.utc(row.FirstCutTime).toDate()
        : null,
      LastCutTime: row.LastCutTime
        ? moment.utc(row.LastCutTime).toDate()
        : null,
    }));
    data.tables[2].rows = data.tables[2].rows.map((row) => {
      row.Timestamp = moment.utc(row["Timestamp"]).toDate();
      return row;
    });

    data.tables[3].rows = data.tables[3].rows.map((row) => {
      row.Datetime = moment.utc(row["Datetime"]).toDate();
      return row;
    });

    data.tables[4].rows = data.tables[4].rows.map((row) => {
      row.Datetime = moment.utc(row["Datetime"]).toDate();
      return row;
    });
    data.tables[5].rows = data.tables[5].rows.map((row) => {
      row.Datetime = moment.utc(row["Datetime"]).toDate();
      return row;
    });
    data.tables[6].rows = data.tables[6].rows.map((row) => {
      row.Datetime = moment.utc(row["Datetime"]).toDate();
      return row;
    });
    data.tables[7].rows = data.tables[7].rows.map((row) => {
      row.Datetime = moment.utc(row["Datetime"]).toDate();
      return row;
    });

    return {
      ok: true,
      data,
    };
  } else {
    return {
      ok: false,
      message: resp.message,
    };
  }
};

export const justifyStrandLosses = async (
  processId: number,
  strandLossCodeId: number,
  comments: string | null,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: "StrandLossCodeId", value: strandLossCodeId },
    { name: "Comments", value: comments },
  ];

  return await apiService.callV2("[CAS].[JustifyStrandLosses]", parameters);
};

type UpsertProcessDataParams = {
  processId: number;
  field: string;
  value: boolean | string | number | Date | null;
};

export const upsertProcessData = async ({
  processId,
  field,
  value,
}: UpsertProcessDataParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: field, value: value },
    { name: "IsManual", value: true },
  ];

  return await apiService.callV2("[CAS].[UpsertProcessData]", parameters);
};

type UpsertProcessParams = {
  processId: number;
  field: string;
  value: boolean | string | number | Date | null;
};

export const upsertProcess = async ({
  processId,
  field,
  value,
}: UpsertProcessParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: field, value: value },
    { name: "IsManual", value: true },
  ];

  return await apiService.callV2("[CAS].[UpsertProcess]", parameters);
};

type UpsertHeatParams = {
  HeatId: number;
  field: string;
  value: any;
};

export const upsertHeat = async ({
  HeatId,
  field,
  value,
}: UpsertHeatParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "HeatId", value: HeatId },
    { name: field, value: value },
  ];

  return await apiService.callV2("[MS].[UpsertHeat]", parameters);
};

export const getCASHeatsForSelector = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "HoursBack", value: 24 }];

  const resp = await apiService.callV2(
    "[CAS].[GetReadyToCastHeats]",
    parameters,
  );
  if (resp.ok) {
    const data = resp.data as ReadyToCastHeatsResponse;
    return {
      ok: true,
      data: data.tables[0].rows,
    };
  } else {
    return {
      ok: false,
      message: resp.message!,
    };
  }
};

type ChangeHeatStatusProps = {
  heatId: number;
  status: string;
};
export const changeCasterHeatStatus = async ({
  heatId,
  status,
}: ChangeHeatStatusProps) => {
  const apiService = new MESApiService();
  const resp = await apiService.callV2("[RBD].[ChangeHeatStatusCommand]", [
    { name: "HeatId", value: heatId },
    { name: "HeatStatusCode", value: status.charAt(0) },
  ]);
  if (resp.ok) {
    const data = resp.data;
    return {
      ok: true,
      data: data.tables[0].rows,
    };
  } else {
    return {
      ok: false,
      message: resp.message!,
    };
  }
};

type UpsertProbeParams = {
  ProbeId: number | null;
  ProcessId: number;
  Timestamp: string;
  Temperature: number | null;
  Oxygen: number | null;
  IsProbeManual: boolean;
};

export const upsertProbe = async ({
  ProbeId,
  ProcessId,
  Timestamp,
  Temperature,
  Oxygen,
  IsProbeManual,
}: UpsertProbeParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProbeId", value: ProbeId },
    { name: "ProcessId", value: ProcessId },
    { name: "Timestamp", value: Timestamp },
    { name: "Temperature", value: Temperature },
    { name: "Oxygen", value: Oxygen },
    { name: "IsProbeManual", value: IsProbeManual },
  ];

  return await apiService.callV2("[CAS].[UpsertProbe]", parameters);
};

type UpsertStrandParams = {
  ProcessId: number | null;
  MoldId: number | null;
  Strand: number | null;
  FirstCutTime: string | null;
  LastCutTime: string | null;
  Pieces: number | null;
  CastTons: number | null;
  SpeedIPMAvg: number | null;
  WaterDeltaTAvg: number | null;
  WaterFlowAvg: number | null;
  WaterTempAvg: number | null;
  IsManual: boolean;
  IsForSale: boolean;
  ShroudingMold: boolean;
  BreakOut: boolean;
};

export const upsertStrandData = async ({
  ProcessId,
  MoldId,
  Strand,
  FirstCutTime,
  LastCutTime,
  Pieces,
  CastTons,
  SpeedIPMAvg,
  WaterDeltaTAvg,
  WaterFlowAvg,
  WaterTempAvg,
  IsManual,
  IsForSale,
  ShroudingMold,
  BreakOut,
}: UpsertStrandParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "MoldId", value: MoldId },
    { name: "Strand", value: Strand },
    { name: "FirstCutTime", value: FirstCutTime },
    { name: "LastCutTime", value: LastCutTime },
    { name: "Pieces", value: Pieces },
    { name: "CastTons", value: CastTons },
    { name: "SpeedIPMAvg", value: SpeedIPMAvg },
    { name: "WaterDeltaTAvg", value: WaterDeltaTAvg },
    { name: "WaterFlowAvg", value: WaterFlowAvg },
    { name: "WaterTempAvg", value: WaterTempAvg },
    { name: "IsManual", value: IsManual },
    { name: "IsForSale", value: IsForSale },
    { name: "ShroudingMold", value: ShroudingMold },
    { name: "BreakOut", value: BreakOut },
  ];

  return await apiService.callV2("[CAS].[UpsertStrandData]", parameters);
};

export const readStrandFromPLC = async ({
  ProcessId,
  Strand,
}: {
  ProcessId: number;
  Strand: number;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "Strand", value: Strand },
  ];

  return await apiService.callV2("[RBD].[ReadCASStrandsFromPLC]", parameters);
};

export const readProbesFromPLC = async ({
  ProcessId,
}: {
  ProcessId: number;
}) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessId", value: ProcessId }];

  return await apiService.callV2("[RBD].[ReadCASProbesFromPLC]", parameters);
};

export const getLastestProcesses = async () => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessCode", value: "C" }];

  return await apiService.callV2("[RBD].[GetLastestNProcesses]", parameters);
};

export const deleteProbeById = async ({ ProbeId }: { ProbeId: number }) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProbeId", value: ProbeId }];

  return await apiService.callV2("[CAS].[DeleteProbe]", parameters);
};

interface PourbackData {
  PourbackId: number | null;
  HeatId: number;
  SourceProcessId: number | null;
  PourbackWeight: number | null;
  PourbackReasonId: number | null;
  SourceTime: Date;
}

export const upsertPourback = async (data: PourbackData) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "PourbackId", value: data.PourbackId },
    { name: "HeatId", value: data.HeatId },
    { name: "SourceProcessId", value: data.SourceProcessId },
    { name: "PourbackWeight", value: data.PourbackWeight },
    { name: "PourbackReasonId", value: data.PourbackReasonId },
    { name: "SourceTime", value: data.SourceTime },
  ];
  return await apiService.callV2("[RBD].[ManagePourback]", parameters);
};

type ReassignMoldParams = {
  ProcessId: number;
  SourceStrand: number;
  TargetStrand: number;
  MoldId: number;
};

export const reassignMold = async ({
  ProcessId,
  SourceStrand,
  TargetStrand,
  MoldId,
}: ReassignMoldParams) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: ProcessId },
    { name: "SourceStrand", value: SourceStrand },
    { name: "TargetStrand", value: TargetStrand },
    { name: "MoldId", value: MoldId },
  ];

  return await apiService.callV2("[CAS].[ReassignMold]", parameters);
};

export const searchProcesses = async (searchTerm: string) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "SearchTerm", value: searchTerm },
    { name: "MaxResults", value: 100 },
    { name: "AssetId", value: "13" },
  ];

  return await apiService.callV2("[RBD].[SearchProcesses]", parameters);
};
